import React from 'react';
import { Check } from 'lucide-react';

const features = [
  'Google Business Profile連携',
  'ワンクリック口コミ同期',
  'AI返信文生成（オーナー口調の学習対応）',
  '店舗数無制限',
  'アンケート・QRコード機能',
  '口コミ分析ダッシュボード',
];

const Pricing: React.FC = () => {
  return (
    <section id="pricing" className="section bg-gray-50">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl font-semibold">シンプルな料金体系</h2>
          <p className="max-w-2xl mx-auto text-lg">
            利用量に合わせて選べる、3つの料金プラン
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {/* 無料プラン */}
          <div className="bg-white rounded-2xl overflow-hidden transition-all duration-300 shadow-apple-lg ring-2 ring-gray-400 transform scale-105">
            <div className="p-8 bg-gray-700 text-white">
              <h3 className="text-2xl font-medium mb-2">無料プラン</h3>
              <div className="flex items-end mb-4">
                <span className="text-3xl font-medium">¥0</span>
                <span className="ml-1 text-sm opacity-75">/月</span>
              </div>
              <p className="text-gray-300">
                まずはお試しで使ってみたい方に
              </p>
            </div>
            <div className="p-8 bg-gray-50">
              <div className="mb-6 px-4 py-3 bg-white rounded-lg text-center shadow-sm">
                <span className="text-sm font-medium text-gray-900">AI返信生成</span>
                <div className="text-2xl font-semibold text-blue-600 mt-1">3コメントまで</div>
              </div>
              <ul className="space-y-4 mb-8">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <span className="mr-2 text-blue-600 mt-1">
                      <Check size={16} />
                    </span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="https://buy.stripe.com/bJe3cueSNfJybUn8lE1gs06"
                className="block w-full text-center btn bg-gray-700 hover:bg-gray-800 text-white"
              >
                無料で始める
              </a>
            </div>
          </div>

          {/* スタンダードプラン */}
          <div className="bg-white rounded-2xl overflow-hidden transition-all duration-300 shadow-apple-lg ring-2 ring-blue-600 transform scale-105">
            <div className="p-8 bg-blue-600 text-white">
              <h3 className="text-2xl font-medium mb-2">スタンダード</h3>
              <div className="flex items-end mb-4">
                <span className="text-3xl font-medium">¥3,000</span>
                <span className="ml-1 text-sm opacity-75">/月</span>
              </div>
              <p className="text-blue-100">
                定期的に口コミ対応が必要な方に
              </p>
            </div>
            <div className="p-8">
              <div className="mb-6 px-4 py-3 bg-blue-50 rounded-lg text-center">
                <span className="text-sm font-medium text-gray-900">AI返信生成</span>
                <div className="text-2xl font-semibold text-blue-600 mt-1">10コメントまで</div>
              </div>
              <ul className="space-y-4 mb-8">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <span className="mr-2 text-blue-600 mt-1">
                      <Check size={16} />
                    </span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="https://buy.stripe.com/aFacN4aCx2WMgaDeK21gs03"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center btn bg-blue-600 hover:bg-blue-700 text-white"
              >
                今すぐ始める
              </a>
            </div>
          </div>

          {/* プレミアムプラン */}
          <div className="bg-white rounded-2xl overflow-hidden transition-all duration-300 shadow-apple-lg ring-2 ring-amber-500 transform scale-105">
            <div className="p-8 bg-amber-700 text-white">
              <h3 className="text-2xl font-medium mb-2">プレミアム</h3>
              <div className="flex items-end mb-4">
                <span className="text-3xl font-medium">¥5,000</span>
                <span className="ml-1 text-sm opacity-75">/月</span>
              </div>
              <p className="text-amber-100">
                多くの口コミに対応したい方に
              </p>
            </div>
            <div className="p-8">
              <div className="mb-6 px-4 py-3 bg-gray-50 rounded-lg text-center">
                <span className="text-sm font-medium text-gray-900">AI返信生成</span>
                <div className="text-2xl font-semibold text-blue-600 mt-1">無制限</div>
              </div>
              <ul className="space-y-4 mb-8">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <span className="mr-2 text-blue-600 mt-1">
                      <Check size={16} />
                    </span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="https://buy.stripe.com/dRm00i6mhgNC4rVdFY1gs05"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center btn bg-amber-700 hover:bg-amber-800 text-white"
              >
                今すぐ始める
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;